import { useSearchParams } from 'react-router-dom';
import { useLanguage } from '@/context/LanguageContext';
import { translations } from '@/data/translations';
import { useProducts, useCategories } from '@/hooks/useSupabase';
import { ProductCard } from '@/components/ProductCard';
import { CategoryFilter } from '@/components/CategoryFilter';
import { ProductGridSkeleton } from '@/components/Skeletons';

export default function CatalogPage() {
  const { t, getLocalizedField } = useLanguage();
  const [searchParams] = useSearchParams();
  const categorySlug = searchParams.get('category');
  
  const { products, loading } = useProducts(categorySlug);
  const { categories } = useCategories();
  
  const activeCategory = categorySlug 
    ? categories.find(c => c.slug === categorySlug) 
    : null;

  return (
    <div className="py-12 md:py-24 px-6 md:px-12 lg:px-24" data-testid="catalog-page">
      <div className="max-w-[1800px] mx-auto">
        {/* Header */}
        <div className="mb-12">
          <h1 className="font-serif text-4xl md:text-5xl text-[#2C2C2C] tracking-tight mb-4">
            {activeCategory 
              ? getLocalizedField(activeCategory, 'name') 
              : t(translations.catalog.title)
            }
          </h1>
          <p className="font-sans text-lg text-[#5D5D5D]">
            {loading ? '...' : `${products.length} ${products.length === 1 ? 'Product' : 'Products'}`}
          </p>
        </div>

        {/* Category Filter */}
        <div className="mb-12">
          <CategoryFilter />
        </div>

        {/* Product Grid */}
        {loading ? (
          <ProductGridSkeleton count={6} />
        ) : products.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
            {products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        ) : (
          <div className="text-center py-24">
            <p className="font-sans text-lg text-[#5D5D5D]">
              {t(translations.catalog.noProducts)}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
